import RenderLayout from "./components/RenderLayout"
export default function CustomActivityTemplate2() {
  console.log("CustomFormTemplate1")
  const ID_TEMPLATE = "custom_activity_template_2"
  const ID_BLOCKS = ["default__custom__block_4", "activity"]
  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Submitted By",
      field: "staff_full_name",
      block: "activity",
      type: "staff",
    },
  ]
  return (
    <RenderLayout
      ID_TEMPLATE={ID_TEMPLATE}
      ID_BLOCKS={ID_BLOCKS}
      listViewCols={listViewCols}
    />
  )
}
